<template>
  <div class="school-notice-board">
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="myData.length"
      class="layout"
    >
      <br>
      <bulletin-list :announcements="myData" />
    </div>
    <div
      v-else
      class="card"
    >
      <p>No new News Bulletin at the moment, check back later</p>
      <Spinner />
    </div>
  </div>
</template>

<script>
import getPosts from '@/composables/getPosts'
import Spinner from '@/components/Spinner.vue'
import BulletinList from '../../components/gallery/BulletinList.vue'

export default {
  name: 'Circular',
  components: { Spinner, BulletinList },
  setup () {
    const { myData, error, load } = getPosts()

    load('circulars')

    return { myData, error }
  }
}
</script>

<style>
  .school-notice-board {
    max-width: 960px;
    margin: 0 auto;
    padding: 0;
  }
</style>
